import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BarIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M15.3599 2.1001H19.4999V3.9001H16.4399L14.9403 6.71186L20.1806 6.71185L12.9 15.1339V19.3501H15.7126L15.7126 21.1501L8.34644 21.1501V19.3501H11.1V15.0649L3.87915 6.71186L12.9003 6.71186L15.3599 2.1001ZM16.2452 8.51186L12.0299 13.3881L7.81452 8.51186L16.2452 8.51186Z"
      />
    </SvgIcon>
  );
});
